import {
  NumericOpenEndQuestion,
  OpenEndQuestion,
  RankingQuestion,
} from "../../../types/Question";

// <number
//   label="Q16"
//   optional="0"
//   size="10"
//   verify="range(0,123)">
//   <title>New Number Question</title>
//   <comment>Please enter a number.</comment>
// </number>
/**
 * Export question as XML-precursor data type.
 *
 * @export
 * @param {RankingQuestion} question
 * @return {*}
 */
export default function toXmlType(question: NumericOpenEndQuestion) {
  return {
    number: {
      _attributes: {
        label: `Q${question.id}`,
        size: `10`,
        // verify="range(0,128)">
      },
      title: question.title,
    },
  };
}
